import { render, staticRenderFns } from "./AssignmentsList.vue?vue&type=template&id=41590f75"
import script from "./AssignmentsList.vue?vue&type=script&lang=ts"
export * from "./AssignmentsList.vue?vue&type=script&lang=ts"
import style0 from "./AssignmentsList.vue?vue&type=style&index=0&id=41590f75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports